export function defaultSelectedItensFormatter(dataSet, type) {
  if (type === 'multi') {
    return dataSet
      .map((data) => data.label.split(' ')[0])
      .reduce((label, others) => `${label}, ${others}`);
  }
  return dataSet.map((data) => data.label);
}
